import { RouteItem } from '@eastcoal/router/types/route'

import {
  HELP_DOC_CREATE_PAGE_PATH,
  HELP_DOC_EDIT_PAGE_PATH,
  HELP_DOC_LIST_PAGE_PATH
} from './constants/path'
import { HELP_DOC_ACTION_UUID, HELP_DOC_PAGE_UUID } from './constants/uuid'

export const helpDocRoute: RouteItem = {
  title: '帮助文档',
  uuid: HELP_DOC_PAGE_UUID,
  hideChildrenInMenu: true,
  children: [
    {
      title: '列表',
      path: HELP_DOC_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '创建',
      path: HELP_DOC_CREATE_PAGE_PATH,
      Component: () => import('./Create/index')
    },
    {
      title: '编辑',
      path: HELP_DOC_EDIT_PAGE_PATH,
      Component: () => import('./Edit/index')
    },
    {
      title: '管理',
      uuid: HELP_DOC_ACTION_UUID
    }
  ]
}
